export default "__VITE_ASSET__cef94b55__"